// part of nuxt
import type { $Fetch, NitroFetchRequest } from "nitropack"
import UrlConfig from "@/utils/UrlConfig"

/**
 * Public company profile data (SEO/AI) served by the KPI service.
 * Only `tenantId` is guaranteed; the remaining fields are populated as
 * customer data becomes available, so they are treated as optional.
 */
export interface CompanyProfile {
  tenantId: string
  name?: string | null
  industry?: string | null
  employees?: number | null
  website?: string | null
}

export function seoRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Returns the public company profile for a tenant, used to generate the
     * tenant's llms.txt.
     * @param tenantId targeted tenant
     * @returns
     */
    async getCompanyProfile(tenantId: string): Promise<CompanyProfile> {
      return fetch<CompanyProfile>(`${UrlConfig.PATH_BASE_KPI}/public/seo/company/${tenantId}`, {
        headers: {
          Accept: "application/json",
        },
      })
    },
  }
}
